<template>
	<el-dialog title="考勤统计" :visible="visible" width="880px" :close-on-click-modal="false"
		@close="$emit('close')" append-to-body>
		<div class="att-tabs">
			<div class="att-tab" :class="{ active: tab === 'day' }" @click="switchTab('day')">每日看板</div>
			<div class="att-tab" :class="{ active: tab === 'month' }" @click="switchTab('month')">月度日历</div>
		</div>

		<!-- 每日看板 -->
		<div v-if="tab === 'day'" v-loading="loading">
			<div class="att-toolbar">
				<el-button size="mini" icon="el-icon-arrow-left" @click="shiftDay(-1)"></el-button>
				<el-date-picker v-model="date" type="date" size="mini" value-format="yyyy-MM-dd"
					format="yyyy-MM-dd" placeholder="选择日期" style="width:150px" @change="loadBoard()"></el-date-picker>
				<el-button size="mini" icon="el-icon-arrow-right" @click="shiftDay(1)"></el-button>
				<el-button size="mini" @click="goToday()">今天</el-button>
				<span class="att-rest-badge" v-if="board.isRest">休息日</span>
				<span class="spacer"></span>
				<el-button size="mini" :type="board.isRest ? 'warning' : 'info'" plain
					@click="toggleRest()">{{ board.isRest ? '取消休息日' : '设为休息日' }}</el-button>
			</div>
			<div class="att-pending-tip" v-if="pendingRows.length">
				<i class="el-icon-bell"></i> {{ pendingRows.length }} 人打卡待确认：
				<el-button v-for="r in pendingRows" :key="r.userId" size="mini" type="success" plain
					@click="confirmRow(r)">{{ r.nickName }}</el-button>
			</div>
			<el-table :data="board.rows" size="small" border>
				<el-table-column label="业务员" prop="nickName" width="110"></el-table-column>
				<el-table-column label="考勤状态" width="220">
					<template slot-scope="s">
						<el-tag v-if="s.row.status === 0" type="warning" size="mini">待确认</el-tag>
						<el-tag v-else-if="s.row.status === 1" type="success" size="mini">正常</el-tag>
						<el-tag v-else-if="s.row.status === 2" type="danger" size="mini">请假</el-tag>
						<el-tag v-else-if="s.row.status === 3" type="warning" size="mini">半天假</el-tag>
						<el-tag v-else-if="s.row.status === 4" type="info" size="mini">休息</el-tag>
						<el-tag v-else size="mini" type="info">未填写</el-tag>
						<el-select v-model="s.row.editStatus" size="mini" placeholder="填写" style="width:96px;margin-left:8px">
							<el-option :value="1" label="正常"></el-option>
							<el-option :value="2" label="请假"></el-option>
							<el-option :value="3" label="半天假"></el-option>
							<el-option :value="4" label="休息"></el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column label="备注">
					<template slot-scope="s">
						<el-input v-model="s.row.editRemark" size="mini" placeholder="请假原因等"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="s">
						<el-button size="mini" type="primary" :disabled="s.row.editStatus == null"
							@click="saveRow(s.row)">保存</el-button>
						<el-button size="mini" type="danger" plain v-if="s.row.status != null"
							@click="clearRow(s.row)">清除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 月度日历 -->
		<div v-else v-loading="calLoading" class="att-cal-wrap">
			<div class="att-cal-left">
				<div v-for="u in roster" :key="u.userId" class="att-cal-user"
					:class="{ active: u.userId === calUserId }"
					@click="switchCalUser(u.userId)">{{ u.nickName }}</div>
			</div>
			<div class="att-cal-right">
				<div class="att-toolbar">
					<el-button size="mini" icon="el-icon-arrow-left" @click="shiftMonth(-1)"></el-button>
					<el-date-picker v-model="month" type="month" size="mini" value-format="yyyy-MM"
						format="yyyy-MM" placeholder="选择月份" style="width:130px" @change="loadCal()"></el-date-picker>
					<el-button size="mini" icon="el-icon-arrow-right" @click="shiftMonth(1)"></el-button>
					<span class="spacer"></span>
					<span class="att-sum">出勤 {{ calSum.normal }} · 请假 {{ calSum.leave }} · 半天假 {{ calSum.half }} · 休息 {{ calSum.rest }} · 待确认 {{ calSum.pending }}</span>
				</div>
				<div class="att-cal">
					<div class="att-cal-head">
						<span v-for="w in ['一', '二', '三', '四', '五', '六', '日']" :key="w">周{{ w }}</span>
					</div>
					<div class="att-cal-grid">
						<div v-for="(c, i) in calCells" :key="i" :class="['att-cal-cell', c.cls || 'blank']"
							@click="c.date && onCalClick(c)" :title="calTip(c)">
							<template v-if="c.date">
								<span class="d">{{ c.day }}</span>
								<span v-if="c.rec && c.rec.status === 0" class="cf" @click.stop="confirmCal(c)">确认</span>
								<span v-else class="t">{{ c.tag }}</span>
							</template>
						</div>
					</div>
				</div>
				<div class="att-legend">
					<span><i class="dot ok"></i>上班</span>
					<span><i class="dot leave"></i>请假</span>
					<span><i class="dot half"></i>半天假</span>
					<span><i class="dot off"></i>休息</span>
					<span><i class="dot pending"></i>待确认</span>
					<span><i class="dot rest"></i>休息日</span>
					<span><i class="dot none"></i>未填写</span>
					<span class="tip">待确认框点「确认」通过；点日期可改状态</span>
				</div>
				<div class="att-cal-edit" v-if="calEdit.date">
					<b>{{ calEdit.date }}</b>
					<el-select v-model="calEdit.status" size="mini" style="width:100px">
						<el-option :value="1" label="正常"></el-option>
						<el-option :value="2" label="请假"></el-option>
						<el-option :value="3" label="半天假"></el-option>
						<el-option :value="4" label="休息"></el-option>
					</el-select>
					<el-input v-model="calEdit.remark" size="mini" placeholder="备注(请假原因等)" style="width:200px"></el-input>
					<el-button size="mini" type="primary" @click="saveCalEdit()">保存</el-button>
					<el-button size="mini" type="danger" plain v-if="calEdit.exists" @click="clearCalEdit()">清除</el-button>
					<el-button size="mini" @click="calEdit.date = null">关闭</el-button>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import bizApi from "../../api/bizApi.js";

export default {
	name: "chatAttendanceDialog",
	props: {
		visible: { type: Boolean, default: false }
	},
	data() {
		return {
			tab: 'day',
			date: this.fmtDay(new Date()),
			month: this.fmtMonth(new Date()),
			loading: false,
			board: { isRest: false, rows: [] },
			roster: [],
			calLoading: false,
			calUserId: null,
			cal: { days: [], restDays: [] },
			calEdit: { date: null, status: 1, remark: '', exists: false }
		}
	},
	computed: {
		pendingRows() {
			return (this.board.rows || []).filter(r => r.status === 0);
		},
		calSum() {
			const s = { normal: 0, leave: 0, half: 0, pending: 0, rest: 0 };
			(this.cal.days || []).forEach(d => {
				if (d.status === 1) s.normal++;
				else if (d.status === 2) s.leave++;
				else if (d.status === 3) s.half++;
				else if (d.status === 0) s.pending++;
				else if (d.status === 4) s.rest++;
			});
			return s;
		},
		calCells() {
			const cells = [];
			if (!this.month) return cells;
			const p = this.month.split('-');
			const y = +p[0], m = +p[1];
			const lead = (new Date(y, m - 1, 1).getDay() + 6) % 7; // 周一起
			const daysInMonth = new Date(y, m, 0).getDate();
			const map = {};
			(this.cal.days || []).forEach(d => { map[d.date] = d; });
			const rests = {};
			(this.cal.restDays || []).forEach(d => { rests[d] = true; });
			for (let i = 0; i < lead; i++) cells.push({ date: null });
			for (let d = 1; d <= daysInMonth; d++) {
				const date = this.month + '-' + ('0' + d).slice(-2);
				const rec = map[date];
				let cls = rests[date] ? 'rest' : 'none';
				let tag = rests[date] ? '休' : '';
				if (rec) {
					if (rec.status === 1) { cls = 'ok'; tag = '班'; }
					else if (rec.status === 2) { cls = 'leave'; tag = '假'; }
					else if (rec.status === 3) { cls = 'half'; tag = '半'; }
					else if (rec.status === 4) { cls = 'off'; tag = '休'; }
					else { cls = 'pending'; tag = '待'; }
				}
				cells.push({ date, day: d, cls, tag, rec, remark: rec && rec.remark ? date + ' ' + rec.remark : '' });
			}
			return cells;
		}
	},
	watch: {
		visible(v) {
			if (v) {
				this.date = this.fmtDay(new Date());
				this.month = this.fmtMonth(new Date());
				if (this.tab === 'day') this.loadBoard();
				else this.loadCal();
			}
		}
	},
	methods: {
		switchTab(t) {
			this.tab = t;
			if (t === 'day' && !this.board.rows.length) this.loadBoard();
			if (t === 'month') this.loadCal();
		},
		loadBoard() {
			if (!this.date) return;
			this.loading = true;
			bizApi.attBoard(this.date).then((d) => {
				// 行内编辑模型: 默认选中当前状态, 备注可改
				(d.rows || []).forEach(r => {
					r.editStatus = r.status === 0 ? null : r.status;
					r.editRemark = r.remark || '';
				});
				this.board = d || { isRest: false, rows: [] };
				if (!this.roster.length && this.board.rows) {
					this.roster = this.board.rows.map(r => ({ userId: r.userId, nickName: r.nickName }));
				}
			}).catch(() => { }).finally(() => { this.loading = false; });
		},
		loadCal() {
			if (!this.month) return;
			this.calLoading = true;
			const done = () => { this.calLoading = false; };
			const fetchCal = () => {
				if (!this.calUserId) { done(); return; }
				bizApi.attCalendar(this.calUserId, this.month).then((d) => {
					this.cal = d || { days: [], restDays: [] };
				}).catch(() => { }).finally(done);
			};
			if (!this.roster.length) {
				// 花名册从月度统计取(含全体业务员)
				bizApi.attStats(this.month).then((d) => {
					this.roster = ((d && d.rows) || []).map(r => ({ userId: r.userId, nickName: r.nickName }));
					if (this.roster.length && !this.calUserId) this.calUserId = this.roster[0].userId;
					fetchCal();
				}).catch(() => done());
			} else {
				if (!this.calUserId) this.calUserId = this.roster[0].userId;
				fetchCal();
			}
			this.calEdit.date = null;
		},
		shiftDay(n) {
			const d = this.parseDay(this.date);
			d.setDate(d.getDate() + n);
			this.date = this.fmtDay(d);
			this.loadBoard();
		},
		goToday() {
			this.date = this.fmtDay(new Date());
			this.loadBoard();
		},
		shiftMonth(n) {
			const p = this.month.split('-');
			const d = new Date(+p[0], +p[1] - 1 + n, 1);
			this.month = this.fmtMonth(d);
			this.loadCal();
		},
		switchCalUser(id) {
			this.calUserId = id;
			this.calEdit.date = null;
			this.loadCal();
		},
		calTip(c) {
			if (!c.date) return '';
			if (c.rec && c.rec.status === 0) return c.date + ' 已打卡待确认，点「确认」通过';
			if (c.rec && (c.rec.status === 2 || c.rec.status === 3))
				return c.date + (c.rec.status === 2 ? ' 请假' : ' 半天假') + (c.remark ? '：' + c.remark : '');
			if (c.rec && c.rec.status === 4) return c.date + ' 休息' + (c.remark ? '：' + c.remark : '');
			if (c.remark) return c.date + ' ' + c.remark;
			return c.date;
		},
		confirmCal(c) {
			bizApi.attConfirm({ userId: this.calUserId, date: c.date }).then(() => {
				this.$message.success('已确认 ' + c.date + ' 打卡');
				this.loadCal();
				this.$emit('confirmed');
			}).catch((e) => this.$message.error((e && e.message) || '确认失败'));
		},
		onCalClick(c) {
			this.calEdit = {
				date: c.date,
				status: c.rec && c.rec.status >= 1 ? c.rec.status : 1,
				remark: c.rec ? (c.rec.remark || '') : '',
				exists: !!c.rec
			};
		},
		saveCalEdit() {
			bizApi.attFill({
				userId: this.calUserId, date: this.calEdit.date,
				status: this.calEdit.status, remark: this.calEdit.remark || ''
			}).then(() => {
				this.$message.success('已保存 ' + this.calEdit.date);
				this.calEdit.date = null;
				this.loadCal();
				this.$emit('confirmed');
			}).catch((e) => this.$message.error((e && e.message) || '保存失败'));
		},
		clearCalEdit() {
			this.$confirm('清除 ' + this.calEdit.date + ' 的考勤记录？', '提示', { type: 'warning' }).then(() => {
				bizApi.attClear({ userId: this.calUserId, date: this.calEdit.date }).then(() => {
					this.$message.success('已清除');
					this.calEdit.date = null;
					this.loadCal();
				}).catch((e) => this.$message.error((e && e.message) || '清除失败'));
			}).catch(() => { });
		},
		toggleRest() {
			bizApi.attRest({ date: this.date, add: !this.board.isRest }).then(() => {
				this.$message.success(this.board.isRest ? '已取消休息日' : '已设为休息日');
				this.loadBoard();
			}).catch((e) => this.$message.error((e && e.message) || '操作失败'));
		},
		saveRow(row) {
			bizApi.attFill({
				userId: row.userId, date: this.date,
				status: row.editStatus, remark: row.editRemark || ''
			}).then(() => {
				this.$message.success('已保存 ' + row.nickName + ' ' + this.date);
				this.loadBoard();
				this.$emit('confirmed');
			}).catch((e) => this.$message.error((e && e.message) || '保存失败'));
		},
		confirmRow(row) {
			bizApi.attConfirm({ userId: row.userId, date: this.date }).then(() => {
				this.$message.success('已确认 ' + row.nickName + ' 打卡');
				this.loadBoard();
				this.$emit('confirmed');
			}).catch((e) => this.$message.error((e && e.message) || '确认失败'));
		},
		clearRow(row) {
			this.$confirm('清除 ' + row.nickName + ' ' + this.date + ' 的考勤记录？', '提示', {
				type: 'warning'
			}).then(() => {
				bizApi.attClear({ userId: row.userId, date: this.date }).then(() => {
					this.$message.success('已清除');
					this.loadBoard();
				}).catch((e) => this.$message.error((e && e.message) || '清除失败'));
			}).catch(() => { });
		},
		parseDay(s) {
			const p = (s || this.fmtDay(new Date())).split('-');
			return new Date(+p[0], +p[1] - 1, +p[2]);
		},
		fmtDay(d) {
			return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
		},
		fmtMonth(d) {
			return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2);
		}
	}
};
</script>

<style lang="scss" scoped>
.att-tabs {
	display: flex;
	gap: 24px;
	border-bottom: 2px solid #e4e7ed;
	margin-bottom: 14px;

	.att-tab {
		padding: 8px 2px;
		cursor: pointer;
		color: #606266;
		border-bottom: 2px solid transparent;
		margin-bottom: -2px;
		font-size: 14px;

		&.active {
			color: #4066d5;
			border-bottom-color: #4066d5;
			font-weight: 600;
		}
	}
}

.att-toolbar {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 12px;

	.spacer {
		flex: 1;
	}

	.att-rest-badge {
		background: #fdf6ec;
		color: #e6a23c;
		border: 1px solid #f5dab1;
		border-radius: 4px;
		padding: 2px 8px;
		font-size: 12px;
	}

	.att-sum {
		color: #606266;
		font-size: 12px;
	}
}

.att-pending-tip {
	background: #fdf6ec;
	border: 1px solid #f5dab1;
	color: #e6a23c;
	border-radius: 6px;
	padding: 8px 12px;
	margin-bottom: 12px;
	font-size: 13px;
	display: flex;
	align-items: center;
	gap: 6px;
	flex-wrap: wrap;
}

.att-cal-wrap {
	display: flex;
	gap: 14px;
	align-items: flex-start;
}

.att-cal-left {
	width: 96px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	gap: 6px;
	max-height: 470px;
	overflow-y: auto;

	.att-cal-user {
		padding: 8px 6px;
		border-radius: 6px;
		text-align: center;
		font-size: 13px;
		color: #606266;
		background: #f5f7fa;
		cursor: pointer;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;

		&:hover {
			background: #e8ecf7;
		}

		&.active {
			background: #4066d5;
			color: #fff;
			font-weight: 600;
		}
	}
}

.att-cal-right {
	flex: 1;
	min-width: 0;
}

.att-cal {
	.att-cal-head {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		gap: 6px;
		margin-bottom: 6px;

		span {
			text-align: center;
			font-size: 12px;
			color: #909399;
		}
	}

	.att-cal-grid {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		gap: 6px;
	}

	.att-cal-cell {
		height: 58px;
		border-radius: 6px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		border: 1px solid #ebeef5;
		background: #fff;

		.d {
			font-size: 14px;
			font-weight: 600;
		}

		.t {
			font-size: 11px;
			margin-top: 2px;
		}

		.cf {
			font-size: 10px;
			background: #67c23a;
			color: #fff;
			border-radius: 8px;
			padding: 1px 10px;
			margin-top: 2px;

			&:hover {
				background: #529c2b;
			}
		}

		&.blank {
			border-color: transparent;
			background: transparent;
			cursor: default;
		}

		&.ok {
			background: #67c23a;
			border-color: #67c23a;
			color: #fff;
		}

		&.leave {
			background: #fdecec;
			border-color: #f6c1c1;
			color: #e05a5a;
		}

		&.half {
			background: #fdf6ec;
			border-color: #f5dab1;
			color: #e6a23c;
		}

		&.pending {
			background: #fff8e6;
			border-color: #ffe9a8;
			color: #d4a017;
		}

		&.rest {
			background: #f2f3f5;
			border-color: #e4e7ed;
			color: #909399;
		}

		&.off {
			background: #eef3fa;
			border-color: #c6d9f5;
			color: #5b7bb2;
		}

		&.none {
			color: #c0c4cc;
		}
	}
}

.att-legend {
	display: flex;
	align-items: center;
	gap: 14px;
	margin-top: 12px;
	font-size: 12px;
	color: #606266;

	.dot {
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 3px;
		margin-right: 4px;
		vertical-align: -1px;

		&.ok { background: #67c23a; }
		&.leave { background: #f6c1c1; }
		&.half { background: #f5dab1; }
		&.pending { background: #ffe9a8; }
		&.off { background: #c6d9f5; }
		&.rest { background: #e4e7ed; }
		&.none { background: #fff; border: 1px solid #ebeef5; }
	}

	.tip {
		color: #909399;
		margin-left: auto;
	}
}

.att-cal-edit {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 12px;
	padding: 10px 12px;
	background: #f5f7fa;
	border-radius: 6px;
}
</style>
